export enum OrderMessageOrigin {
  Customer,
  Supplier,
  Driver,
}
